import React from 'react'
import {Link} from 'react-router-dom'
import './Footer.css'

const Footer = () => {
    return (
        <footer id='footer-wrapper'>
            <div className='quick-links'>
            <h2>Quick Links</h2>
            <ul>
            <Link to='/'><h3>Home</h3></Link>
            <Link to='/events'><h3>Events</h3></Link>
            <Link to='/blog'><h3>Blogs</h3></Link>
            </ul>
            </div>
            <div className='contact-us'>
            <h2>Connect with us!</h2>
            <div className='icon-container'>
            <a href="https://www.instagram.com/avalokana_society/"><i class="fab fa-instagram"></i></a>
            <a href="https://www.facebook.com/avalokana.bmsce"><i class="fab fa-facebook-square"></i></a>
            <a href="https://twitter.com/AvalokanaSoc"><i class="fab fa-twitter"></i></a>
            </div>
            <h3>Email: avalokanasociety@gmail.com</h3>
            </div>
            <img className='footer-image' src='/images/asura.png' alt='dance'/>
        </footer>
    )
}

export default Footer
